module.exports = __webpack_public_path__ + "static/media/reading-blue.dda55b00.svg";